<template>
  <div class="footer-navblock">
    <h3>{{ title }}</h3>
    <ul v-for="(item, index ) in items" :key="index">
      <li v-if="item[3]">
        <a target="_blank" :href="item[1]" v-if="item[2]">{{ item[0] }}</a>
        <router-link :to="item[1]" v-else>{{ item[0] }}</router-link>
      </li>
      <li class="li-address" v-else>
        {{ item[0] }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'FooterBlock',
    props: {
      title: { type: String, default: 'Title' },
      items: { type: Array, default: () => [] }
    },
  }
</script>

<style scoped lang="scss">

  @import '../../pfx.scss';

  .footer-navblock {
    @include column(1/5, $cycle: 5);
  }

  h3 {
    color: black;
    font-size: 16px;
    font-weight: 600;
  }

  li {
    font-size: 12px;
    font-weight: 400;
    display: block;
    margin: 8px 0;
    width: 500px;
    list-style: none;

    a {
      text-decoration: none;
      color: black;
    }
    a:hover {
      text-decoration: underline;
    }
  }

  .li-adddress {
    font-size: 12px;
    font-weight: 400;
    display: block;
    margin: 8px 0;
    width: 1000px;
    list-style: none;
    line-height: 1.0;
  }

  ul {
    font-size: 12px;
    font-weight: 400;
    display: block;
    margin: 8px 0;
    list-style: none;

    a {
      text-decoration: none;
      color: black;
    }
    a:hover {
      text-decoration: underline;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/FooterBlock.vue